import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import Header from './Header';
import Footer from './Footer';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import { Helmet } from "react-helmet";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

function About() {
    const [testimonial, settestimonial] = useState([]);
    const [aboutpage, setaboutpage] = useState([]);
    const [activitydatas, setActivityDatas] = useState(null);

      useEffect(() => {
        fetch("https://planjourneysglobal.com/admin/api/home_page/banners/about")
          .then(res => res.json())
          .then(res => setActivityDatas(res.data?.[0] || null))
          .catch(err => console.log(err));
      }, []);


 useEffect(() => {
    fetch("https://planjourneysglobal.com/admin/api/testimonils")
      .then((res) => res.json())
      .then((data) => {
        settestimonial(data?.data || []); // API key: data.data
      })
      .catch((err) => console.log("API Error:", err));
  }, []);

  useEffect(() => {
    fetch("https://planjourneysglobal.com/admin/api/about_page")
      .then((res) => res.json())
      .then((data) => {
        setaboutpage(data?.data || []); // API key: data.data
      })
      .catch((err) => console.log("API Error:", err));
  }, []);

     return (
    <>
      <Helmet>
          <title>{aboutpage.meta_title}</title>
          <meta name="description" content={aboutpage.meta_discription} />
          {aboutpage.meta_keyword && <meta name="keywords" content={aboutpage.meta_keyword} />}
          {aboutpage.slug && <link rel="canonical" href={aboutpage.slug} />}
    
          {/* Open Graph */}
          <meta property="og:title" content={aboutpage.meta_title} />
          <meta property="og:description" content={aboutpage.meta_discription} />
          {aboutpage.image && <meta property="og:image" content={aboutpage.image} />}
          {aboutpage.slug && <meta property="og:url" content={aboutpage.slug} />}
          <meta property="og:type" content="website" />
    
          {/* Twitter */}
          <meta name="twitter:title" content={aboutpage.meta_title} />
          <meta name="twitter:description" content={aboutpage.meta_discription} />
          {aboutpage.image && <meta name="twitter:image" content={aboutpage.image} />}
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
      <Header />

  {/* Start Breadcrumb section */}
  <div
    className="breadcrumb-section"
    style={{
          backgroundImage: activitydatas?.image_url
            ? `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${activitydatas.image_url})`
            : "none"
        }}
  >
    <div className="container">
      <div className="banner-content">
        <h1>{aboutpage.title}</h1>
      </div>
    </div>
  </div>
  {/* End Breadcrumb section */}
  {/* About Section Start*/}
  <div className="about-section pt-100 mb-100 mt-30">
    <div className="container">
      <div className="about-wrapper">
        <div className="row align-items-center justify-content-between">
          <div
            className="col-xl-6 col-lg-7 wow animate fadeInLeft"
            data-wow-delay="200ms"
            data-wow-duration="1500ms"
          >
            <div className="about-content">
              <div className="section-title">
                <h2>{aboutpage.about_best_service_title}</h2>
                <br></br>
                {aboutpage.best_agency}
              
              </div>
            
            </div>
          </div>
          <div
            className="col-lg-5 d-lg-block d-none wow animate fadeInRight"
            data-wow-delay="200ms"
            data-wow-duration="1500ms"
          >
            <div className="about-img">
              <img
  src={aboutpage?.best_agency_main_image}
  alt="Best Agency"
  onError={(e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = "/assets/img/no-image.png";
  }}
/>

            </div>
          </div>

      
        </div>
      </div>
    </div>
  </div>
  {/* About Section End*/}
  {/* home1 service Section Start*/}
  <div className="home1-service-section mb-100">
    <div className="container">
      <div className="service-wrapper">
        <div
          className="row justify-content-center wow animate fadeInDown"
          data-wow-delay="200ms"
          data-wow-duration="1500ms"
        >
          <div className="col-lg-9">
            <div className="section-title">
              <h2>{aboutpage.about_best_service_title}</h2>
              <svg
                height={6}
                viewBox="0 0 872 6"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M5 2.5L0 0.113249V5.88675L5 3.5V2.5ZM867 3.5L872 5.88675V0.113249L867 2.5V3.5ZM4.5 3.5H867.5V2.5H4.5V3.5Z" />
              </svg>
            </div>
          </div>
        </div>
      <ul
  className="service-list wow animate fadeInUp"
  data-wow-delay="200ms"
  data-wow-duration="1500ms"
>
  {aboutpage?.about_best_service_places?.map((item, index) => (
    <li className="single-service" key={index}>
      <div className="icon">
        <img
          src={item?.image}
          alt={item?.heading}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = "/assets/img/no-image.png";
          }}
        />
      </div>

      <div className="content">
        <h4>{item?.heading}</h4>
        <p>{item?.description}</p>
      </div>
    </li>
  ))}
</ul>

      </div>
    </div>
  </div>
  {/* home1 service Section End*/}

  {/* Why Choose Visa Section Start*/}
  <div className="about-why-choose-section mb-100">
    <div className="container">
     <div className="row justify-content-center">
  <div className="col-lg-8">
    <div className="section-title text-center">
      <h2>Why Travel with Us?</h2>
      <p>{aboutpage?.travel_with_us_des}</p>
    </div>
  </div>
</div>
    <div className="row g-xl-4 g-lg-3 g-4 mt-0">
  {aboutpage?.travel_with_us?.map((item, index) => (
    <div
      className="col-lg-3 col-sm-6 wow animate fadeInDown"
      data-wow-delay={`${(index + 1) * 200}ms`}
      data-wow-duration="1500ms"
      key={index}
    >
      <div
        className={`why-choose-card ${
          index === 1 ? "two" : index === 2 ? "three" : index === 3 ? "four" : ""
        }`}
      >
        <img
          src={item?.image}
          alt={item?.paragraph?.replace(/\r?\n/g, " ")}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = "/assets/img/no-image.png";
          }}
        />

        <h5>
          {item?.paragraph
            ?.split(/\r?\n/)
            .map((line, i) => (
              <span key={i}>
                {line}
                <br />
              </span>
            ))}
        </h5>
      </div>
    </div>
  ))}
</div>


    </div>
  </div>
  {/* Why Choose Visa Section End*/}

  {/* About Video Section Start*/}
  {/* <div className="about-video-section mb-100">
    <div className="container">
      <div className="video-wrap">
        <img src="/assets/img/innerpages/about-video-img.jpg" alt="" />
        <a
          data-fancybox="video-player"
          href="https://www.youtube.com/watch?v=u31qwQUeGuM"
          className="play-btn"
        >
          <i className="bi bi-play-fill" />
          <div className="waves-block">
            <div className="waves wave-1" />
            <div className="waves wave-2" />
            <div className="waves wave-3" />
          </div>
        </a>
      </div>
    </div>
  </div> */}
  {/* About Video Section End*/}
  {/* home1 testimonial Section Start*/}
  {testimonial?.length > 0 && (
  <div className="home1-testimonial-section mb-100">
    <div className="container">
      <div
        className="row justify-content-center mb-50 wow animate fadeInDown"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
      >
        <div className="col-xl-6 col-lg-8">
          <div className="section-title text-center">
            <h2>Hear It from Travelers</h2>
            <p>
              We go beyond just booking trips—we create unforgettable travel
              experiences that match your dreams!
            </p>
          </div>
        </div>
      </div>
      <div className="row mb-40">
        <div className="col-lg-12">
          <div className="swiper home1-testimonial-slider">
             <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      slidesPerView={3}
      spaceBetween={10}
      navigation={true}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      loop={true}
       className="swiper-wrapper"
    >           {testimonial.map((item, index) => (
              <SwiperSlide className="swiper-slide" key={index}>
                <div className="testimonial-card">
                  <div className="author-area">
                    <div className="author-img">
                      <img
                        src="assets/img/home1/testimonial-author-img1.png"
                        alt=""
                      />
                    </div>
                    <div className="author-info">
                      <h5>{item.name} </h5>
                      <span>{item.specialization}</span>
                    </div>
                  </div>
                 
                  <h5>{item.title}</h5>
                  <div className="content">
                    <p>{item.content}

                    </p>
                  </div>
                </div>
              </SwiperSlide>
                 ))}
            </Swiper>
          </div>
        </div>
      </div>

    </div>
  </div>
  )}

<div className="guider-page pt-100 mb-100">
  <div className="container">
 <div
        className="row justify-content-center mb-30 wow animate fadeInDown"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
      >
        <div className="col-xl-6 col-lg-8">
          <div className="section-title text-center">
            <h2>Our Team</h2>
           
          </div>
        </div>
      </div>
   

    <div className="row gy-md-5 gy-4">
      {aboutpage?.about_team_members?.map((member, index) => (
        <div
          className="col-lg-3 col-md-4 col-sm-6 wow animate fadeInDown"
          data-wow-delay="200ms"
          data-wow-duration="1500ms"
          key={index}
        >
          <div className="tour-guide-card two">

            <div className="guide-img-wrap">
              <a className="guide-img">
                <img
                  src={member?.image}
                  className="img-responsive"
                  alt={member?.name || "Team Member"}
                  onError={(e) => {
                    e.currentTarget.src = "/assets/img/no-image.png";
                  }}
                />
              </a>

              <ul className="social-list ss">

                {member?.number && (
                  <li>
                    <a href={`tel:${member.number}`} title="Call">
                      <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g><path d="M15.5646 11.7424L13.3317 9.50954C12.5343 8.7121 11.1786 9.03111 10.8596 10.0678C10.6204 10.7855 9.82296 11.1842 9.10526 11.0247C7.51037 10.626 5.35726 8.55261 4.95854 6.87797C4.71931 6.16024 5.19778 5.36279 5.91548 5.12359C6.95216 4.80461 7.27113 3.44895 6.47369 2.65151L4.24084 0.418659C3.60288 -0.139553 2.64595 -0.139553 2.08774 0.418659L0.572591 1.93381C-0.942555 3.5287 0.73208 7.75516 4.48007 11.5032C8.22807 15.2512 12.4545 17.0056 14.0494 15.4106L15.5646 13.8955C16.1228 13.2575 16.1228 12.3006 15.5646 11.7424Z"></path></g></svg>
                    </a>
                  </li>
                )}

                {member?.email && (
                  <li>
                    <a href={`mailto:${member.email}`} title="Email">
                     <svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 24 24"
  fill="none"
  stroke="black"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <path d="M4 4h16v16H4z" />
  <polyline points="22,6 12,13 2,6" />
</svg>

                    </a>
                  </li>
                )}

              </ul>
            </div>

            <div className="guide-info">
              <h5>{member?.name}</h5>
              <span>{member?.degination}</span>
            </div>

          </div>
        </div>
      ))}
    </div>

  </div>
</div>






  {/* home1 testimonial Section End*/}
  {/* Counter Section Start*/}
  <div className="counter-section">
    <div className="container">
      <div className="row gy-md-5 gy-4">



{aboutpage?.best_agencies?.map((item, index) => {
  const value = item?.heading?.replace(/[^\d]/g, "") || 0;
  const suffix = item?.heading?.replace(/\d+/g, "").trim();

  return (
    <div className="col-lg-3 col-sm-6 divider " key={index}>
      <div class="single-counter">
      <div className="icon"> <img src={item?.image} alt={item?.paragraph} onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = "/assets/img/no-image.png"; }} /> </div>
      <div className="counter">
        <div className="number">
           <h2 className="counter">
            <CountUp 
          end={value} 
          duration={2} 
          enableScrollSpy 
          scrollSpyOnce 
        />{suffix}
           </h2>
        </div> 
          <span>{item?.paragraph}</span>
      </div>
       

   
    </div>
      </div>
  );
})}



</div>

    </div>
  </div>
  {/* Counter Section End*/}

         <Footer />
    </>
  );
}

export default About;
